import React from 'react';
import {AdvancedMarker, PinElement} from "react-google-map-wrapper";
import {useGeolocated} from "react-geolocated";

type Props = {
    onPositionUpdate: (position: GeolocationPosition) => void
}

const UserLocation: React.FC<Props> = (props) => {
    const [userLocation, setUserLocation] = React.useState<GeolocationCoordinates>()

    useGeolocated({
        watchPosition: true,
        onSuccess: (position: GeolocationPosition) => {
            setUserLocation(position.coords)
            props.onPositionUpdate(position)
        }
    })

    return userLocation ? (
        <AdvancedMarker lat={userLocation.latitude} lng={userLocation.longitude}>
            <PinElement glyphColor={'white'} background={'#76bd4c'} borderColor={'#76bd4c'} scale={0.8} />
        </AdvancedMarker>
    ) : <></>
}

export default UserLocation
